import React, { useState } from "react";
import { Tab } from "semantic-ui-react";
import { ListAccidentTypes } from "../../../components/Admin/AccidentTypes/ListAccidentTypes/ListAccidentTypes";
import { useLanguage } from "../../../contexts";
import "./AccidentTypes.scss";

export function AccidentTypes() {
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;
  const [reload, setReload] = useState(false);
  const onReload = () => setReload((prev) => !prev);

  const panes = [
    {
      menuItem: t("active_accident_types"),
      render: () => (
        <Tab.Pane attached={false}>
          <ListAccidentTypes accidentTypesActive={true} reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: t("inactive_accident_types"),
      render: () => (
        <Tab.Pane attached={false}>
          <ListAccidentTypes accidentTypesActive={false} reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <div className="accident-types-page" style={{ padding: "0 0 1.5rem" }}>
      <div className="accident-types-page-header-wrapper">
        <div className="accident-types-page-header">
          <span className="accident-types-page-title">{t("accident_types")}</span>
        </div>
      </div>
      <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
    </div>
  );
}
